import styles from '/builds/sitegeist/cts-reisen/.build/releases/1/src/Cts.CtsReisenDe.Catalog/Resources/Private/Fusion/Application/AvailableContingents/AvailableContingents.css';
import script from '/builds/sitegeist/cts-reisen/.build/releases/1/src/Cts.CtsReisenDe.Catalog/Resources/Private/Fusion/Application/AvailableContingents/AvailableContingents.tsx';

export const prototypeName = 'dgP32291a7UQKW3XJKb8ulPZgD8WvPHbN61wGpj0cNGKXW8b1yt1jJ4JnXrAFoaKrr25vlfWg8w8r2obsLv7XqN8jrf4rge';
export {styles};
export {script};